var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayMatterport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3906 13.5917C15.6314 13.4602 15.9248 13.4708 16.1556 13.6191L26.6556 20.3691C26.8702 20.5071 27 20.7448 27 21C27 21.2552 26.8702 21.4929 26.6556 21.6309L16.1556 28.3809C15.9248 28.5292 15.6314 28.5398 15.3906 28.4083C15.1498 28.2768 15 28.0244 15 27.75V14.25C15 13.9756 15.1498 13.7232 15.3906 13.5917ZM16.5 15.6237V26.3763L24.8631 21L16.5 15.6237Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.3763V15.6237L24.8631 21L16.5 26.3763Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayMatterport);
export default __webpack_public_path__ + "static/media/play_matterport.020da134c2fd09663e0b1e891ac96c98.svg";
export { ForwardRef as ReactComponent };